import React from "react";

const AssignmentType = (props) => {
    switch (props.ass_type) {
        case "Assignment":
        return (
          <>
            <div className="assessment-01 ">
                <p className="as-text-blue"><i className="fal fa-file"></i> <span className="">Assignment</span></p>
            </div>
          </>
        );
        break;
        case "Internal Exam":
            return (
              <>
                <div className="assessment-01">
                    <p className="as-text-green"><i className="fal fa-file"></i> <span className="">Internal Exam</span></p>
                </div>
              </>
            );
        break;
        case "External Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-orange"><i className="fal fa-university"></i> <span className="">External Exam</span></p>
                </div>
              </>
            );
        break;
        case "KM Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-orange"><i className="fal fa-file"></i> <span className="">KM Exam</span></p>
                </div>
              </>
            );
        break;
        case "PM Exam":
            return (
              <>
                <div className="assessment-01">
                  <p className="as-text-red"><i className="fal fa-file"></i> <span className="">PM Exam</span></p>
                </div>
              </>
            );
        break;
        case "Special Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-orange"><i className="fal fa-file"></i> <span className="">Special Exam</span></p>
                </div>
              </>
            );
        case "Test":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-red"><i className="fal fa-file"></i> <span className="">Test</span></p>
                </div>
              </>
            );
        break;

        case "PoE-Formative":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-blue"><i className="fal fa-folder-tree"></i> <span className="">PoE-Formative</span></p>
                </div>
              </>
            );
        break;

        case "PoE-Summative":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-green"><i className="fal fa-folder-tree"></i> <span className="">PoE-Summative</span></p>
                </div>
              </>
            );
        break;

        case "PoE-Informal Activities":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-red"><i className="fal fa-folder-tree"></i> <span className="">PoE-Informal Activities</span></p>
                </div>
              </>
            );
        break;

        case "Survey":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-blue"><i className="fal fa-file"></i> <span className="">Survey</span></p>
                </div>
              </>
            );
        break;
        case "Supplementary Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-blue"><i className="fal fa-file"></i> <span className="">Supplementary Exam</span></p>
                </div>
              </>
            );
        break;
        case "Sick Test":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-blue"><i className="fal fa-file"></i> <span className="">Sick Test</span></p>
                </div>
              </>
            );
        break;
        case "KM Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-orange"><i className="fal fa-file"></i> <span className="">KM Exam</span></p>
                </div>
              </>
            );
        break;
        case "PM Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-red"><i className="fal fa-file"></i> <span className="">PM Exam</span></p>
                </div>
              </>
            );
        break;
        case "Special Exam":
            return (
              <>
                <div className="assessment-01">
                <p className="as-text-orange"><i className="fal fa-file"></i> <span className="">Special Exam</span></p>
                </div>
              </>
            );
        break;
        default:
        return (
          <>
            <div className="assessment-01">
                <p className="as-red"><i className="fal fa-times"></i>Unknown Status</p>
            </div>
          </>
        );
        break;
    }
}
export default AssignmentType;
